import React, { createContext, useState } from 'react';

import Routes from './routes/Routes';

import { configureFakeBackend } from './helpers';

// Themes
// For Default import Theme.scss
import './assets/scss/Theme.scss';

// For Dark import Theme-Dark.scss
// import './assets/scss/Theme-Dark.scss';

// configure fake backend
// configureFakeBackend();

export const userContext = createContext(null);
export const excelUploadContext = React.createContext(null)

const App = () => {
    const [isUser, setIsUser] = useState(false);

    const [excelUpload, setExcelUpload] = React.useState({
        selectedFiles: undefined,
        previewImages: [],
        progressInfos: [],
        message: [],
        fileInfos: [],
    });

    return (
        <userContext.Provider value={[isUser, setIsUser]}>
            <excelUploadContext.Provider value={[excelUpload, setExcelUpload]} >
                <>
                    <Routes></Routes>
                </>
            </excelUploadContext.Provider>
        </userContext.Provider>

    );
};

export default App;
